import { render, staticRenderFns } from "./AbsenceNotificationsList.vue?vue&type=template&id=3cc02c46"
import script from "./AbsenceNotificationsList.vue?vue&type=script&lang=ts"
export * from "./AbsenceNotificationsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports